import { AppThunk } from "../../store/AppThunkType";
import {
    loadPermitSuccessful,
    loadPermitStarted,
    savePermitStarted,
    savePermitSuccessful,
    loadPermitSubmitterSuccessful,
    updatePermitLastAccessSuccessful,
    loadPermitFailed,
    updatePermitLastAccessFailed,
} from "./actions";
import database from "../../Database";
import { Permit, getPermitGeofencing } from "../../models/Permit";
import LocationService, { GetPositionOptions, isLocationError } from "../../LocationService";
import { checkUserWithinGeofence } from "../../arcgisUtils";

export function loadPermit(id: string): AppThunk {
    return function (dispatch) {
        dispatch(loadPermitStarted());

        database
            .queryPermit(id)
            .then((result) => {
                dispatch(loadPermitSuccessful(result));
            })
            .catch((error) => {
                dispatch(loadPermitFailed(error));
            });
    };
}

export function savePermit(permit: Permit): AppThunk {
    return function (dispatch, getState) {
        dispatch(savePermitStarted());

        database.savePermit(permit, getState().permitPage.newFiles).then((result) => {
            dispatch(savePermitSuccessful(result));
        });
    };
}

export function loadPermitSubmitter(userId: string): AppThunk {
    return function (dispatch) {
        database.queryUser(userId).then((result) => {
            dispatch(loadPermitSubmitterSuccessful(result));
        });
    };
}

export function updatePermitLastAccess(
    permit: Permit,
    userId: string,
    options: GetPositionOptions = { maximumAge: 0 }
): AppThunk {
    return function (dispatch) {
        if (!LocationService.isLocationFresh(permit.lastAccess) || Object.keys(options).length > 0) {
            LocationService.getLocationLog(userId, options)
                .then((locationLog) => {
                    const geofencing = getPermitGeofencing(permit);
                    let geofencingError = null;
                    let withinGeofence = false;

                    if (geofencing?.status && ["enforced", "warning"].includes(geofencing.status)) {
                        if (!permit.areas || permit.areas.length === 0) {
                            geofencingError =
                                "Geofencing is enabled for this permit but no geofencing areas are defined. Please contact support.";
                        } else {
                            try {
                                withinGeofence = checkUserWithinGeofence(
                                    permit.areas,
                                    locationLog.longitude,
                                    locationLog.latitude,
                                    geofencing.toleranceMeters ?? 0
                                );
                                geofencingError = withinGeofence
                                    ? null
                                    : `You are currently ${
                                          (geofencing.toleranceMeters ?? 0) > 0
                                              ? `more than ${geofencing.toleranceMeters}m`
                                              : ""
                                      } outside the permit boundary. Please move within the boundary to sign the permit and try again. ${
                                          geofencing.status === "warning"
                                              ? "If you proceed, your action will be recorded for audit purposes."
                                              : ""
                                      } `;
                            } catch (error) {
                                geofencingError =
                                    "Unexpected error while checking geofence boundaries. Please contact support.";
                            }
                        }
                    }
                    dispatch(updatePermitLastAccessSuccessful(permit.id, locationLog, withinGeofence, geofencingError));
                })
                .catch((error) => {
                    dispatch(
                        updatePermitLastAccessFailed(
                            permit.id,
                            error.message,
                            isLocationError(error) ? error.key : null
                        )
                    );
                });
        }
    };
}
